import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['rejectReason', 'rejectInput', 'form'];

  toggleRejectReason(event) {
    if (event.target.value === 'reject') {
      this.rejectReasonTarget.classList.remove('hidden');
    } else {
      this.rejectReasonTarget.classList.add('hidden');
      this.rejectInputTarget.value = '';
    }
  }

  validateAndSubmit(event) {
    const action = this.element.querySelector('input[name="submission_action"]:checked')?.value;
    if (action === 'reject') {
      const reason = this.rejectInputTarget.value.trim();
      if (!reason) {
        event.preventDefault();
        this.rejectInputTarget.focus();
        this.rejectInputTarget.setCustomValidity('Un motif de refus est requis.');
        this.rejectInputTarget.reportValidity();
      } else {
        this.rejectInputTarget.setCustomValidity('');
      }
    }
  }
}
